/**
 * useTutorLiveNotificationTap (web) — rien : le web ne reçoit pas de notification à toucher, comme
 * l'ancien live, qui ne montait `NotificationSubscriptionHandler` qu'en natif.
 */
import { type TutorTapOutcome, type TutorTapSession } from "./tutorLiveNotificationTap"

export function useTutorLiveNotificationTap(
    session: TutorTapSession | null,
    onOutcome: (outcome: TutorTapOutcome) => void
): void {
    void session
    void onOutcome
}
